module.exports = __webpack_public_path__ + "img/Brain.a4a76a7.png";